module.exports = __webpack_public_path__ + "media/images/brand/150/MARQUESBRANDINGCO LOGO VERTICAL-9ff2008fc1fa65da9fb43f997dc2a455.png";